// This component loads the "Add to necklace" dropdowns on additional pearl items in the cart
const cartNecklaceDropdownLoader = {
    cart: null,
    cartJson: null,
    pearlElements: null,
    setCart: async function() {
        this.cart = await fetch(`${Shopify.routes.root}cart.js`);
        this.cartJson = await this.cart.json();
    },
    setPearlElements: function() {
        this.pearlElements = document.querySelectorAll(".cart-page line-item.trackable");
    },
     populateNecklaceDropdowns: async function() {
        await this.setCart();
        this.setPearlElements();
        this.pearlElements.forEach((pearl) => {
            const dropdownWrapper = pearl.querySelector(".necklace-dropdown-wrapper");
            if(dropdownWrapper) {
                this.fetchNecklaces(pearl).then(response => {
                    this.createDropdown(response, pearl);
                });
            }
        });
    },

    fetchNecklaces: async function(pearl) {
        const url = window.location.origin + "/apps/necklace-tracker/all";
        try {
            const response = await fetch(url);
            if(!response.ok) {
                throw new Error("necklaces could not be fetched");
            }
            const result = await response.json()
            return result
        } catch (error) {
            console.error(error.message)
        }
    },

    setRowLoading: function(pearl, isLoading) {
        const row = pearl.closest('tr');
        if(!row) {
            return;
        }

        row.classList.toggle('necklace-updating', isLoading);
        row.setAttribute('aria-busy', isLoading ? 'true' : 'false');

        if(!isLoading) {
            row.querySelectorAll('.necklace-update-spinner').forEach((spinner) => {
                spinner.remove();
            });
            return;
        }

        // The remove links are duplicated across breakpoints, so collect every
        // cell that holds one — only the visible cell's spinner will show
        const cells = new Set();
        row.querySelectorAll('a[href*="/cart/change"]').forEach((removeLink) => {
            const cell = removeLink.closest('td');
            if(cell) {
                cells.add(cell);
            }
        });

        if(!cells.size) {
            const fallback = row.querySelector('td');
            if(fallback) {
                cells.add(fallback);
            }
        }

        cells.forEach((cell) => {
            if(cell.querySelector('.necklace-update-spinner')) {
                return;
            }

            const spinner = document.createElement('div');
            spinner.className = 'necklace-update-spinner';
            spinner.setAttribute('role', 'status');
            spinner.innerHTML = '<span class="visually-hidden">Updating item…</span>';
            cell.appendChild(spinner);
        });
    },

    createDropdown: function(data, pearl) {
        const lineItemId = pearl.dataset.lineItemId;
        const lineItem = this.cartJson.items.filter((item) => item.key == lineItemId);

        if(data.length) {
            const wrapper = pearl.querySelector('.necklace-dropdown-wrapper');
            if(wrapper) {
                const dropdown = document.createElement('select');
                wrapper.appendChild(dropdown);
                dropdown.id = `dropdown-${lineItemId}`;
                dropdown.classList.add('necklace-dropdown');
                dropdown.classList.add('select');
                const chevron = wrapper.querySelector('svg');
                if(chevron) {
                    wrapper.appendChild(chevron);
                }
                const dropdownDefault = document.createElement('option');
                dropdownDefault.innerHTML = "Add pearls to your necklace";
                dropdown.appendChild(dropdownDefault)
                dropdownDefault.value = null;
                let optionMatched = false;
                data.forEach((option) => {
                    if(option["type"] == pearl.dataset.pearlType) {
                        optionMatched = true;
                        const dropdownOption = document.createElement('option');
                        dropdownOption.innerHTML = option.name;
                        dropdown.appendChild(dropdownOption)
                        dropdownOption.value = option.name;
                        if(option.name == lineItem[0]?.properties["Assigned Necklace"]) {
                            dropdownOption.selected = true;
                        }
                    }
                });
                if(optionMatched) {
                    dropdown.addEventListener('change', function(event) {
                        cartNecklaceDropdownLoader.updateLineItem(event, pearl.dataset.lineItemId, lineItem, pearl.dataset.unitId, pearl);
                    });
                } else {
                    dropdown.remove();
                }
            }

        }
    },

    updateLineItem: async function(event, lineItemId, lineItem, unitId, pearl) {
        const necklaceNameProp = {
            "Assigned Necklace": event.target.value
        }
        let newProperties = {
            ...lineItem[0].properties,
            ...necklaceNameProp
        }
        if(unitId) {
            newProperties["_unit_id"] = unitId;
        }
        if(event.target.value == 'null') {
            delete newProperties["Assigned Necklace"];
        }

        // Remember the line's position: changing properties mints a new key,
        // but doesn't move the line within the cart.
        const lineIndex = this.cartJson
            ? this.cartJson.items.findIndex((item) => item.key === lineItemId)
            : -1;

        if(pearl) {
            this.setRowLoading(pearl, true);
        }

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'id': lineItemId,
                    'properties': newProperties
                })
            });

            if(!response.ok) {
                throw new Error("line item could not be updated");
            }

            const cart = await response.json();
            this.cartJson = cart;

            const updatedItem = lineIndex > -1
                ? cart.items[lineIndex]
                : cart.items.find((item) => item.key === lineItemId);

            if(!updatedItem || !pearl) {
                return;
            }

            // Keep every reference to the old key in sync
            pearl.dataset.lineItemId = updatedItem.key;
            lineItem[0] = updatedItem;

            const dropdown = pearl.querySelector('.necklace-dropdown');
            if(dropdown) {
                dropdown.id = `dropdown-${updatedItem.key}`;
            }

            this.updateRemoveLink(pearl, updatedItem.key);
        } catch (error) {
            console.error(error.message);
        } finally {
            if(pearl) {
                this.setRowLoading(pearl, false);
            }
        }
    },

    updateRemoveLink: function(pearl, newKey) {
        // The remove link sits in a sibling <td>, so walk up to the row first
        const row = pearl.closest('tr');
        if(!row) {
            return;
        }

        // There are several remove links per row — only one is visible at a
        // given breakpoint, so all of them need the new key
        const removeLinks = row.querySelectorAll('a[href*="/cart/change"]');
        removeLinks.forEach((removeLink) => {
            const url = new URL(removeLink.getAttribute('href'), window.location.origin);
            // Themes can render either ?id=<key> or ?line=<n>; only the key goes stale
            if(url.searchParams.has('id')) {
                url.searchParams.set('id', newKey);
                removeLink.setAttribute('href', `${url.pathname}${url.search}`);
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById('cart-form');
    const checkoutBtn = document.querySelector('#cart-form [name="checkout"]');
    if(checkoutBtn && form) {
//         listening for click on the button because listening for the form submission didn't work
//         There is code from the Easify app (i think) that is stopping event propagation on this button
        document.addEventListener('click', function(event) {
            const checkoutBtn = event.target.closest('[name="checkout"]');

            if (checkoutBtn) {
                if(checkoutBtn.classList.contains('proceed')) {
                    return;
                }
                event.preventDefault();
                event.stopImmediatePropagation();

                //logged in
                if(__st.cid) {
                    const dropdowns = form.querySelectorAll('.necklace-dropdown');
                    //if there are no necklace dropdowns, proceed to checkout without showing modal
                    if(!dropdowns.length) {

                        proceedToCheckout();
                    } else {
                        let unregisteredPearls = false;
                        dropdowns.forEach((dropdown) => {
                            if(!dropdown.value || dropdown.value === "null") {
                                unregisteredPearls = true;
                            }
                        });
                        if(unregisteredPearls) {
                            //show modal
                            const modal = document.getElementById('cart-modal-loggedin');
                            if(modal) {
                                const noBtn = modal.querySelector('#proceed-without-registering');
                                if(noBtn) {
                                    noBtn.addEventListener("click", proceedToCheckout);
                                }
                                modal.show()
                            }
                        }
                        else {
                            proceedToCheckout();
                        }

                    }
                }
                //logged out
                else {
                    const trackableItems = document.querySelectorAll('.line-item.trackable');
                    if(trackableItems.length) {
                        //show modal
                        const modal = document.getElementById('cart-modal-guest');
                        if(modal) {
                            const noBtn = modal.querySelector('#proceed-without-registering');
                            if(noBtn) {
                                noBtn.addEventListener("click", proceedToCheckout);
                            }
                            modal.show()
                        }
                    } else {
                        //if there are no pearl items, proceed to checkout without showing modal
                        proceedToCheckout();
                    }
                }
            }
            function proceedToCheckout() {
                //click the button again, this time indicating that event propagation can happen as normal
                checkoutBtn.classList.add('proceed');
                checkoutBtn.click();
            }
        }, { capture: true });

    }
    //if logged in, populate dropdowns
    if(__st.cid) {
        cartNecklaceDropdownLoader.populateNecklaceDropdowns();
    }


});

